export default __webpack_public_path__ + "static/media/logo-03.f8ddfa03.png";